<ds-carousel
  [ariaLabel]="'Multiple Slides'"
  [autoPlay]="false"
  [showPlayPause]="false"
  [indicatorsPosition]="'center'"
>
  <ds-carousel-slide
    *ngFor="let slide of slides; let index = index"
    [ariaLabel]="slideLabel + ' ' + (index + 1)"
  >
    <ds-picture
      class="center"
      [src]="slide.image"
      [alt]="slide.ariaLabel"
      ratio="auto"
    ></ds-picture>
  </ds-carousel-slide>
</ds-carousel>
